function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.69477 10.6952C8.67661 10.6952 9.47255 9.89927 9.47255 8.91743C9.47255 7.93558 8.67661 7.13965 7.69477 7.13965C6.71293 7.13965 5.91699 7.93558 5.91699 8.91743C5.91699 9.89927 6.71293 10.6952 7.69477 10.6952Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97287 15.3613C10.4331 15.3613 10.8062 14.9882 10.8062 14.528V14.2502C10.8062 12.4724 9.0451 11.3613 7.6951 11.3613C6.3451 11.3613 4.58398 12.4724 4.58398 14.2502V14.528C4.58398 14.9882 4.95708 15.3613 5.41732 15.3613H9.97287Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0764 4.58398H10.3416C9.92319 4.58398 9.58398 4.93379 9.58398 5.36523V7.1375C10.0478 7.56641 10.3416 8.1875 10.3416 8.88086C10.3416 9.21836 10.2709 9.53809 10.1467 9.82813C10.2092 9.84531 10.2739 9.85742 10.3416 9.85742H11.8567V10.5342C11.8567 10.6998 11.987 10.834 12.1474 10.834C12.2048 10.834 12.2611 10.8164 12.3088 10.7836L13.656 9.85742H15.0764C15.4948 9.85742 15.834 9.50762 15.834 9.07617V5.36523C15.834 4.93379 15.4948 4.58398 15.0764 4.58398Z",
  fill: "white"
});

function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_Icon.fd851c56.svg";
export { ForwardRef as ReactComponent };